/**
 * Broadcast messages are plain text (the app shows them as text). Older ones
 * may hold HTML; it is turned into text here instead of being injected into
 * the page, because a broadcast is written by a brand admin and read by
 * everyone on the brand. `DOMParser` does not run scripts.
 */
/**
 * Only markup an editor would have produced counts as legacy HTML: a closing
 * tag or a line break. A plain-text placeholder such as `<PROMO10>` is kept.
 */
const LEGACY_HTML = /<\/[a-z][a-z0-9]*\s*>|<br\s*\/?>/i;

export function broadcastContentToText(content?: string | null): string {
  if (!content) return '';
  if (!LEGACY_HTML.test(content)) return content;
  const withBreaks = content
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/<\/(p|div|li|h[1-6]|tr)>/gi, '\n')
    .replace(/<li[^>]*>/gi, '• ');
  const doc = new DOMParser().parseFromString(withBreaks, 'text/html');
  doc.querySelectorAll('script, style, noscript, template').forEach(node => node.remove());
  return (doc.body.textContent ?? '').replace(/\n{3,}/g, '\n\n').trim();
}
